import { render, staticRenderFns } from "./GridForm.vue?vue&type=template&id=1b51681a"
import script from "./GridForm.vue?vue&type=script&lang=js"
export * from "./GridForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports